export const STALE_TIME_SWR = 0
export const CACHE_TIME_SWR = 1000 * 60 * 15

type TanstackStaleCacheTime = {
	stale: number
	cache: number
}

export const CACHE_SWR: TanstackStaleCacheTime = { stale: 0, cache: CACHE_TIME_SWR }

export const CACHE_FIRST: TanstackStaleCacheTime = { stale: Infinity, cache: CACHE_TIME_SWR * 2 }

export const CACHE_FIRST_LONG: TanstackStaleCacheTime = { stale: Infinity, cache: CACHE_TIME_SWR * 6 }

export const CACHE_NETWORK_ONLY: TanstackStaleCacheTime = { stale: STALE_TIME_SWR, cache: 0 }

export const CACHE_INFINITY: TanstackStaleCacheTime = { stale: Infinity, cache: Infinity }
